<template>
  <div class="resource-ratio">
    <div class="banner">
      <img src="@/assets/dataQuery/dp-ld-zy1.png" alt />
    </div>
    <div class="picture" v-if="isPictrue">
      <div id="main"></div>
      <p>（点击乡镇数据图可查看该乡镇数据详情）</p>
    </div>
    <button v-show="!isPictrue" @click="back" v-if="jurisdiction">返回</button>
    <studyTable
      v-show="!isPictrue"
      :tableData="tableDataTemp"
      :pages="pages"
      :columns="columns"
      :num="num"
    ></studyTable>
  </div>
</template>
<script>
import studyTable from "./module/_studyTable";
export default {
  data() {
    return {
      allData: 360,
      temps: [],
      echarts: require("echarts"),
      isPictrue: true,
      optionData: [],
      jurisdiction:true,
      tableData: [],
      columns: [
        { name: "学习对象", prop: "town" },
        { name: "学习人", prop: "name" },
        { name: "学习方式", prop: "typename" },
        { name: "学习信息", prop: "title" }
      ],
      tableDataTemp: [],
      pages: 1,
      num: 0
    };
  },
  methods: {
    back() {
      this.isPictrue = true;
      this.getMsg();
    },
    circle() {
      // console.log(this.optionData);
      let data = [];
      this.optionData.filter((item, index) => {
        data.push({});
        data[index].name = item[0];
        data[index].value = item[1];
      });
      // console.log(data);

      let bar_dv = document.getElementById("main");
      let myChart = this.echarts.init(bar_dv);

      let option = {
        tooltip: {
          trigger: "item",
          axiosPointer: {
            type: "shadow"
          }
        },
        series: [
          {
            type: "pie",
            radius: "60%",
            center: ["50%", "50%"],
            selectedMode: "single",
            data: data,
            label: {
              normal: {
                formatter: "{b}\n{c}  "
              }
            }
          }
        ]
      };
      myChart.on("click", params => {
        this.getDetail(params.name);
      });
      myChart.setOption(option);
    },
    getMsg() {
      this.axios
        .get("/api/Statistics/Count")
        .then(e => {
          // console.log(e.data);
          switch (e.data.code) {
            case 0:
              console.log(this.optionData);

              this.optionData = e.data.msg;
              this.circle();
              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDetail(name) {
      this.isPictrue = false;
      this.tableDataTemp = [];
      this.axios
        .post("/api/Statistics/getTownShip", {
          c2township: name,
          c2name: sessionStorage.getItem("token")
        })
        .then(e => {
          switch (e.data.code) {
            case 0:
              // console.log(e.data);
              this.tableData = e.data.msg;
              this.num = this.tableData.length;
              this.tableData.some((item, index) => {
                if (index == 10) return true;
                else {
                  this.tableDataTemp.push(item);
                }
              });
              this.pages = Number.parseInt(
                this.tableData.length % 10 > 0
                  ? this.tableData.length / 10 + 1
                  : this.tableData.length /10
              );

              break;

            default:
              break;
          }
        });
    }
  },
  mounted: function() {
    if (sessionStorage.getItem("roleid") == 2) {
      this.getMsg();
    } else {
      this.getDetail(sessionStorage.getItem("town"));
      this.jurisdiction = false
    }
  },
  components: {
    studyTable
  }
};
</script>
<style lang='scss' scoped>
.resource-ratio {
  button {
    border: none;
    background: #fcbe54;
    border-radius: 0.08rem;
    font-size: 0.28rem;
    color: #fff;
    padding: 0.1rem 0.3rem;
    margin: 0.2rem;
  }
  .picture {
    #main {
      width: 100%;
      height: 8rem;
    }
    p {
      text-align: center;
      color: #999999;
    }
  }
  .banner {
    img {
      width: 100%;
    }
    text-align: center;
  }
  padding-top: 0.9rem;
  font-size: 0.3rem;
  background: #fff;
  min-height: 100vh;
}
</style>